export default __webpack_public_path__ + "static/media/pending.72a0616a.png";